import { Component, Input } from '@angular/core';

@Component({
  selector: 'cert-access-blocked',
  templateUrl: './access-blocked.component.html',
  styleUrls: ['./access-blocked.component.css'],
  standalone: false,
})
export class AccessBlockedComponent {
  @Input() title = 'Access Blocked';
  @Input() message = 'You do not have permission to access this resource.';
  @Input() icon = 'bi-shield-exclamation';
}
